import { render } from "./TranslationInput.vue?vue&type=template&id=64f415db"
import script from "./TranslationInput.vue?vue&type=script&lang=js"
export * from "./TranslationInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__